import React from 'react'
import {graphql} from 'gatsby'

import Layout from '../../components/Layout'
import EventsSection from '../../components/EventsSection'
import IntroSection from './components/IntroSection'
import MomentsSections from './components/MomentsSection'
import TeamSection from './components/TeamSection'
import SponsorsSection from './components/SponsorsSection'
import MembershipSection from './components/MembershipSection'
import JoinSection from './components/JoinSection'

const IndexPage = ({data: dataObj}) => {
	const data = dataObj.associations.childPagesJson.childPagesJsonWithRelativePaths
	return <Layout footerBack='gray' seo={{routeUrl: data.url, ...data.seo}}>
		<IntroSection data={data.intro}/>
		<EventsSection data={data.events}/>
		<MomentsSections data={data.moments}/>
		<TeamSection data={data.team}/>
		<SponsorsSection data={data.sponsorsPartners}/>
		<MembershipSection data={data.membership}/>
		<JoinSection data={data.join}/>
	</Layout>
}


export default IndexPage

export const query = graphql`
{
	associations: file(relativePath: {eq: "pages/associationsPage.json"}) {
    childPagesJson {
      childPagesJsonWithRelativePaths {      	
      	url
      	intro {
      		title
      		text
      		goals {
      			title
      			items {
      				text
      			}
      		}
      		join {
      			title
      			button {
      				label
      				link
      			}
      		}
      	}
      	
      	events {
      		title
      		bullets {
      			text
      		}
      		text
      		button {
      			label
      			link
      		}
      	}
      	
      	moments {
      		title
      		button {
      			label
      		}
      		items {
      			youtubeUrl
      			big: image {
				  childImageSharp {
					fluid(maxWidth: 2000) {
					...GatsbyImageSharpFluid
					}
				  }
      			}
      			
      			small: image {
				  childImageSharp {
					fluid(maxWidth: 600) {
					...GatsbyImageSharpFluid
					}
				  }
      			}
      		}
      	}
      	
      	team {
      		title
      		members {
      			photo {
					childImageSharp {
						fixed(width: 200, height: 150, cropFocus: NORTH) {
						  ...GatsbyImageSharpFixed
						}
					  }
				  }
      			name
      			position
      			socials {
					twitter
					linkedin
      			}
      			companyName
      			text
      		}
      	}
      	
      	sponsorsPartners {
      		sponsors {
      			title
      			items {
      				icon {
					  childImageSharp {
						fluid(maxWidth: 100) {
						  ...GatsbyImageSharpFluid
						}
					  }
      				}
      				link
      			}
      			button {
      				label
      				link
      			}
      		}
      		partners {
      			title
      			items {
      				icon {
      					childImageSharp {
						fluid(maxWidth: 100) {
						  ...GatsbyImageSharpFluid
						}
					  }
      				}
      				link
      			}
      			button {
      				label
      				link
      			}
      		}
      	}
      	
      	membership {
      		title
      		text
      		discountLabel
      		perk1 {
      			title
      			meta
      			text
      			discount
      		}
      		perk2 {
      			title
      			text
      			discount
      		}
      		perk3 {
      			title
      			text
      			button {
      				label
      				link
      			}
      			discount
      		}
      	}      	
      	
      	join {
      		title
      		text
      		button {
      			label
      			link
      		}
      	}
      	
        seo {
        	title
          description
          author
          metaImage {
            publicURL
          }
        }
      }
    }
  }
}
`
